import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-dark-card relative overflow-hidden" data-id="element-231" data-mp="1d0cp9qc68bfb">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-232" data-mp="1rqbj5gwp10oz" />
      <div className="max-w-4xl mx-auto text-center" data-id="element-233" data-mp="1mtbcp4vxlvxc">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-234" data-mp="z2foehqopiuu">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5" data-id="element-235" data-mp="u3unsh7isx5v"><span className="text-2xl" data-id="element-236" data-mp="183m62u52kzpo">🏆</span></div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-237" data-mp="13zy20lfncm96">The most complete aerial silks teaching library for instructors worldwide</h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-238" data-mp="2jfepr3c1yn4s">Aerial Silks Teacher Ready™</h3>
          <p className="text-base md:text-lg text-gray-300 mb-10" data-id="element-239" data-mp="2ffcy7n017a38">100 ready-to-teach classes · 5 Strategic Bonuses · Everything ready to use from today</p>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-240" data-mp="2gth4pge8o95x">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-black p-6 rounded-2xl border border-dark-border" data-id="element-241" data-mp="2kwn8mhdvpo98">
            {['This is not a collection of random moves copied from the internet.', 'This is not a theoretical manual you need to rewrite before it works in a real class.', 'This is not content designed for a different kind of teacher that you have to completely adapt.'].map(item => <div key={item} className="flex items-start gap-3" data-id="element-242" data-mp="223t2mcy8h6h5"><X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-243" data-mp="26wvxqpinsnzg" /><p className="text-gray-400 text-sm" data-id="element-244" data-mp="26yp7weshdqc7">{item}</p></div>)}
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 relative overflow-hidden" data-id="element-245" data-mp="19gymfs8g8t9h"><div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-246" data-mp="2hpo05fcj9zno" /><div className="flex items-start gap-3 relative z-10" data-id="element-247" data-mp="2crcp51ai5j3v"><Check className="text-gold shrink-0 mt-1" size={20} data-id="element-248" data-mp="2qjj3qiy0bi17" /><p className="text-white font-medium text-base leading-relaxed" data-id="element-249" data-mp="2qj10h2cxg3js">This is a complete professional teaching library — so you walk into every class completely prepared, confident, and ready to deliver a session your students will genuinely feel.</p></div></motion.div>
        </div>
      </div>
    </section>;
}